import { useTranslation } from "react-i18next";
type SubscriptionDetailsProps = {
  paymentDetails: boolean;
  cost: number | string;
};
export default function SubscriptionDetails(props: SubscriptionDetailsProps) {
  const { paymentDetails, cost } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.payment",
  });
  return (
    <div className="w-full flex flex-col gap-6">
      <div className="w-full">
        <h4 className="text-gray-400 mb-1 text-sm leading-4">
          {t("subscriptionCost")}
        </h4>
        <div className="w-full flex items-end gap-1 ">
          <p className="text-brandblue-600 text-[2rem] leading-7 font-semibold">
            {t("price", { value: cost })}
          </p>
          <p className="text-xs text-brandblue-300">{t("singlePayment")}</p>
        </div>
        <p className="mt-2 text-gray-500 text-[10px] leading-4">
          {t("priceType")}
        </p>
      </div>
      {paymentDetails && (
        <div className="w-full">
          <ul>
            <li className="w-full flex  border-b border-gray-100  items-center justify-between mb-4 pb-3">
              <p className="text-gray-400 text-base leading-4">{t("total")}</p>
              <p className="text-gray-500 font-medium text-sm">
                {t("price", { value: cost })}
              </p>
            </li>
            <li className="w-full flex items-center border-b border-gray-200 justify-between mb-4 pb-3">
              <p className="text-gray-400 text-base leading-4">{t("taxes")}</p>
              <p className="text-gray-500 font-medium text-sm">
                {t("price", { value: "0.00" })}
              </p>
            </li>
            <li className="w-full flex items-center justify-between mb-4 pb-2">
              <p className="text-gray-600 text-base leading-4 font-medium">
                {t("totalPrice")}
              </p>
              <p className="text-gray-700 font-medium text-lg leading-6">
                {t("price", { value: cost })}
              </p>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
